<template>
  <div class="main-box" v-loading="submitLoading">
    <div class="title">
      <strong @click="$router.push('/merchantProduct')" style="cursor:pointer"
        ><i class="el-icon-back"></i
      ></strong>
      <span
        v-if="
          $route.query.productCode != undefined &&
            $route.query.productCode != ''
        "
      >
        编辑品项</span
      >
      <span v-else>创建品项</span>
    </div>
    <div class="nav-menu">
      <div class="item" @click="scrollInto('one')" title="基础信息">
        基础信息
      </div>
      <div class="item" @click="scrollInto('two')" title="菜品构成">
        菜品构成
      </div>
      <div class="item" @click="scrollInto('three')" title="菜品构成">
        商品图片
      </div>
      <div class="item" @click="scrollInto('four')" title="打印配置">
        小程序设置
      </div>
    </div>
    <div class="main-content">
      <el-row>
        <el-col
          ><div class="base-info">
            <span class="line"></span> <span id="one">基础信息</span>
          </div></el-col
        >
      </el-row>
      <el-form :data="form" label-width="140px">
        <div style="display:flex;">
          <div>
            <el-form-item label="品项名称:" required>
              <el-input
                @input="getPinYin"
                v-model="form.productName"
                style="width:320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="基础价格:" required>
              <el-input
                @input="changePrice"
                v-model="form.normalPrice"
                style="width:320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员价:">
              <el-input
                v-model="form.memberPrice"
                style="width:320px"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="菜品分类:" required>
              <el-select
                @change="changeSel"
                clearable
                value-key="categoryCode"
                v-model="form.productType"
                style="width:320px"
              >
                <el-option
                  :label="item.categoryName"
                  :value="item"
                  v-for="(item, i) in dishType"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="小程序售价:">
     <el-input v-model="form.onlineSalePrice"  style="width:320px"></el-input>
  </el-form-item> -->
            <el-form-item label="库存:">
              <el-input v-model="form.stock" style="width:320px"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="品项规格:">
          <div
            style="border:1px solid #e8e8e8;margin-bottom:16px"
            v-for="(item, i) in form.specsDimAttrList"
            :key="i"
          >
            <div class="dishType-head">
              <div class="left">
                <span style="font-size:17px">规格 {{ i + 1 }}</span>
                <span v-if="item.defaultFlag == 1" class="default-text"
                  >默认</span
                >
              </div>
              <div class="right" @click="deleteOne(i)"><span>删除</span></div>
            </div>
            <div
              style="padding:14px;padding-top:8px;padding-bottom:0"
              class="inline-form"
            >
              <el-form :data="form" :inline="true" label-position="top">
                <el-form-item label="规格名称" required>
                  <el-select
                    @change="changeSel"
                    v-model="item.sizeName"
                    clearable
                    value-key="dimCode"
                    style="width:130px"
                  >
                    <el-option
                      v-for="(itemName, iName) in typeName"
                      :key="iName"
                      :label="itemName.dimName"
                      :value="itemName"
                    ></el-option>
                    <el-option value=" "></el-option>
                    <div
                      style="font-size:14px;color:#ff6000;height:34px;cursor:pointer;
       display: flex;justify-content: center;align-items: center;
       position: absolute;bottom: 0;background: #fff;width: 128px"
                      @click="$router.push('/merchantProductSpecification')"
                    >
                      <i style="margin-right:6px" class="el-icon-plus"></i
                      ><span>新建规格</span>
                    </div>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="form.specsDimAttrList.length != 1"
                  class="is-default"
                  label="是否默认"
                >
                  <el-radio
                    label="1"
                    @change="doDefault(item, i)"
                    v-model="item.defaultFlag"
                    >{{ "" }}</el-radio
                  >
                </el-form-item>
                <el-form-item label="基础价格" required>
                  <el-input v-model="item.normalPrice" style="width:130px">
                    <span slot="suffix" style="color:#333;padding-right:8px"
                      >元</span
                    >
                  </el-input>
                </el-form-item>
                <el-form-item label="会员价">
                  <el-input v-model="item.memberPrice" style="width:130px">
                    <span slot="suffix" style="color:#333;padding-right:8px"
                      >元</span
                    >
                  </el-input>
                </el-form-item>
                <el-form-item label="设置餐盒">
                  <el-input style="width:90px" v-model="item.lunchBoxPrice">
                    <span slot="suffix" style="color:#333;padding-right:8px"
                      >元</span
                    >
                  </el-input>
                </el-form-item>
                <el-form-item label="预估成本">
                  <el-input v-model="item.costPrice" style="width:130px">
                    <span slot="suffix" style="color:#333;padding-right:8px"
                      >元</span
                    >
                  </el-input>
                </el-form-item>
                <el-form-item style="display:none" label="条形码 ">
                  <el-input
                    v-model="item.barCode"
                    style="width:130px"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="addOne" @click="addOneType">
            <i class="el-icon-plus"></i>
            <span style="margin-left:3px">添加规格</span>
          </div>
        </el-form-item>
        <el-form-item label="是否为称重菜品:">
          <el-radio label="0" v-model="form.isWeighSell">非称重</el-radio>
          <el-radio label="1" v-model="form.isWeighSell">称重</el-radio>
        </el-form-item>
        <el-form-item label="菜品单位:">
          <el-input style="width:370px" v-model="form.unit"></el-input>
        </el-form-item>
        <el-form-item label="拼音助记码:">
          <el-input style="width:370px" v-model="form.pinyin"></el-input>
        </el-form-item>
        <el-row>
          <el-col
            ><div id="two" class="base-info">
              <span class="line"></span> <span>菜品构成</span>
            </div></el-col
          >
        </el-row>
        <el-form-item label="做法:" class="text-center">
          <div
            class="groupByType"
            v-show="
              item.productDimAttrList != null &&
                item.productDimAttrList.length != 0
            "
            v-for="(item, i) in form.practiceDimList"
            :key="i"
          >
            <div class="top">
              <div class="left">
                分组 {{ i + 1 }}: <span>{{ item.dimName }}</span>
              </div>
              <div @click="deleteOneGroup(i, item.dimName)" class="right">
                删除分组
              </div>
            </div>
            <el-table :data="item.productDimAttrList">
              <el-table-column
                align="center"
                label="序号"
                type="index"
              ></el-table-column>
              <el-table-column
                align="center"
                label="名称"
                prop="attrName"
              ></el-table-column>
              <el-table-column
                align="center"
                label="价格"
                prop="price"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span
                    style="cursor:pointer"
                    @click="
                      deleteSelectCook(i, scope.$index, scope.row.attrName)
                    "
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-button style="margin-top:12px" class="myBtn" @click="getLeftType"
            >添加做法</el-button
          >
        </el-form-item>
        <el-form-item label="加料:" class="text-center">
          <div
            class="groupByType"
            v-show="
              item.productDimAttrList != null &&
                item.productDimAttrList.length != 0
            "
            v-for="(item, i) in form.feedDimList"
            :key="i"
          >
            <div class="top">
              <div class="left">
                分组 {{ i + 1 }}: <span>{{ item.dimName }}</span>
              </div>
              <div class="right" @click="doleteAddGroup(i, item.dimName)">
                删除分组
              </div>
            </div>
            <el-table :data="item.productDimAttrList">
              <el-table-column
                align="center"
                label="序号"
                type="index"
              ></el-table-column>
              <el-table-column
                align="center"
                label="名称"
                prop="attrName"
              ></el-table-column>
              <el-table-column
                align="center"
                label="价格"
                prop="price"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span
                    style="cursor:pointer"
                    @click="
                      deleteSelectAdd(i, scope.$index, scope.row.attrName)
                    "
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-button style="margin-top:12px" class="myBtn" @click="addBut()"
            >添加加料</el-button
          >
        </el-form-item>
        <el-row>
          <el-col
            ><div class="base-info">
              <span class="line"> </span> <span id="three">商品图片</span>
            </div></el-col
          >
        </el-row>
        <el-form-item label="列表图:">
          <el-upload
            class="avatar-uploader"
            :action="$uploadURL"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="轮播图:">
          <el-upload
            :file-list="bannerList"
            :on-success="bananerSuccess"
            :action="$uploadURL"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="详情图:">
          <el-upload
            :file-list="detailList"
            :on-success="detailSuccess"
            :action="$uploadURL"
            list-type="picture-card"
            :on-preview="handlePictureCardPreviewDetail"
            :on-remove="handleRemoveDetail"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleDetail">
            <img width="100%" :src="dialogImageUrlDetail" alt="" />
          </el-dialog>
        </el-form-item>
        <el-row>
          <el-col
            ><div id="four" class="base-info">
              <span class="line"></span> <span>小程序设置</span>
            </div></el-col
          >
        </el-row>
        <el-form-item class="long-label" label="是否上架 (小程序):">
          <el-switch
            v-model="form.isVisible"
            active-color="#F59A23"
            inactive-color="#dcdfe6"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="小程序原价:">
          <el-input
            v-model="form.onlineNormalPrice"
            style="width:320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="小程序售价:" required>
          <el-input
            v-model="form.onlineSalePrice"
            style="width:320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="小程序商品描述:">
          <el-input
            v-model="form.onlineSaleDesc"
            style="width:320px"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-dialog title="做法选择" :visible.sync="dialogCookType" width="800px">
        <div class="box-main">
          <div class="left">
            <div
              @click="searchLeft('全部', -1, null)"
              :class="{ item: true, active: leftTypeActive == -1 }"
            >
              全部
            </div>
            <div
              @click="searchLeft(cook.dimName, index, cook.dimCode)"
              :class="{ item: true, active: leftTypeActive == index }"
              v-for="(cook, index) in leftType"
              :key="index"
            >
              {{ cook.dimName }}
            </div>
          </div>
          <div class="right">
            <div class="top">
              <el-input
                v-model="cookName"
                class="h32"
                placeholder="请输入做法名称"
              ></el-input>
              <el-button
                class="h32 btn-my"
                style="margin-left:12px"
                @click="searchByName"
              >
                <i
                  style="font-size:16px;font-weight:700"
                  class="el-icon-search"
                ></i>
                查询</el-button
              >
              <el-button
                @click="reset"
                style="background:#fff"
                class="h32 btn-my"
              >
                重置</el-button
              >
            </div>
            <el-table
              ref="tableRights"
              :row-key="getRowKeys"
              @selection-change="handleSelectionChange"
              :data="tableRight"
              width="100%"
              height="400px"
              style="font-size:14px;"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
              ></el-table-column>
              <el-table-column
                width="60px"
                label="序号"
                type="index"
              ></el-table-column>
              <el-table-column
                label="做法名称"
                prop="attrName"
              ></el-table-column>
              <el-table-column label="变价金额" prop="price"></el-table-column>
              <el-table-column label="做法组" prop="dimName"></el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 已选项 -->
        <div
          style="margin-bottom:9px;color:#222;font-size:16px"
          v-if="selectCook.length != 0"
        >
          <span>已选 （{{ selectCook.length }}）</span>
        </div>
        <div class="hasSelect">
          <div
            v-for="(item, i) in selectCook"
            :key="i"
            @click="cancelSelectCook(i, item.attrCode)"
            class="item"
          >
            {{ item.attrName }} <i class="el-icon-close"></i>
          </div>
        </div>
        <!--  -->
        <span slot="footer" class="dialog-footer">
          <div @click="goToDetailCook" class="red">新建做法</div>
          <div>
            <el-button class="btnAll btnCancel" @click="dialogCookType = false"
              >取 消</el-button
            >
            <el-button
              class="btnAll btnSubmit"
              type="primary"
              @click="cookTypeButton"
              >确 定</el-button
            >
          </div>
        </span>
      </el-dialog>
      <!--  -->
      <el-dialog title="加料选择" :visible.sync="dialogAddMore" width="800px">
        <div class="box-main">
          <div class="left">
            <div
              @click="searchLeft('全部', -1, null)"
              :class="{ item: true, active: leftTypeActive == -1 }"
            >
              全部
            </div>
            <div
              @click="searchLeft(cook.dimName, index, cook.dimCode)"
              :class="{ item: true, active: leftTypeActive == index }"
              v-for="(cook, index) in AddLeft"
              :key="index"
            >
              {{ cook.dimName }}
            </div>
          </div>
          <div class="right">
            <div class="top">
              <el-input
                v-model="addName"
                class="h32"
                placeholder="请输入做法名称"
              ></el-input>
              <el-button
                @click="searchByAddName"
                class="h32 btn-my"
                style="margin-left:12px"
              >
                <i
                  style="font-size:16px;font-weight:700"
                  class="el-icon-search"
                ></i>
                查询</el-button
              >
              <el-button
                @click="reset"
                style="background:#fff"
                class="h32 btn-my"
              >
                重置</el-button
              >
            </div>
            <el-table
              ref="tableRight"
              :row-key="getRowKeys"
              @selection-change="handleSelectionChangeAdd"
              :data="tableRight"
              width="100%"
              height="400px"
              style="font-size:14px;"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
              ></el-table-column>
              <el-table-column
                width="60px"
                label="序号"
                type="index"
              ></el-table-column>
              <el-table-column
                label="做法名称"
                prop="attrName"
              ></el-table-column>
              <el-table-column label="变价金额" prop="price"></el-table-column>
              <el-table-column label="做法组" prop="dimName"></el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 已选项 -->
        <div
          style="margin-bottom:9px;color:#222;font-size:16px"
          v-if="selectAdd.length != 0"
        >
          <span>已选 （{{ selectAdd.length }}）</span>
        </div>
        <div class="hasSelect">
          <div
            v-for="(item, i) in selectAdd"
            :key="i"
            @click="cancelSelectAdd(i, item.attrCode)"
            class="item"
          >
            {{ item.attrName }} <i class="el-icon-close"></i>
          </div>
        </div>
        <!--  -->
        <span slot="footer" class="dialog-footer">
          <div @click="goToDetailAdd" class="red">新建加料</div>
          <div>
            <el-button class="btnAll btnCancel" @click="dialogAddMore = false"
              >取 消</el-button
            >
            <el-button class="btnAll btnSubmit" @click="addButton"
              >确 定</el-button
            >
          </div>
        </span>
      </el-dialog>
      <!--  -->
    </div>
    <div class="foot">
      <el-button class="btnAll btnCancel" @click="$router.go(-1)"
        >取消</el-button
      >
      <el-button class="btnAll btnSubmit" @click="submit"
        >保存并创建
        <i v-if="saveLoading" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { pinyin } from "pinyin-pro";
export default {
  data() {
    return {
      imageUrl: "",
      bannerList: [],
      detailList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      dialogImageUrlDetail: "",
      dialogVisibleDetail: false,
      submitLoading: false,
      cookName: "",
      addName: "",
      rightTableData: {
        merchantCode: "",
        dimType: "practice",
        dimCode: "",
        attrName: ""
      },
      saveLoading: false,
      dialogAddMore: false,
      selectCook: [],
      selectAdd: [],
      leftDimName: "",
      leftType: [],
      AddLeft: [],
      tableRight: [],
      leftTypeActive: -1,
      dishType: [], //菜品分类下拉框
      typeName: [], //规格名称下拉
      dialogCookType: false,
      form: {
        merchantCode: "",
        merchantName: "",
        productName: "", //菜品名称
        normalPrice: "",
        memberPrice: "",
        onlineSalePrice: "",
        stock: "",
        productType: {},
        categoryCode: "", //分类编码
        categoryName: "", //  分类名称
        isWeighSell: "0", //是否称重
        unit: "", //单位
        pinyin: "",
        specsDimAttrList: [
          //   {
          //   sizeName:{},
          //   dimName:'',
          //   defaultFlag:'1',
          //   normalPrice:'',
          //   memberPrice:'',
          //   costPrice:'',
          //   barCode:'',
          //   lunchBoxPrice:''
          // },
        ],
        practiceDimList: [], //做法
        // practiceList:[],
        feedDimList: [], //加料
        onlineSaleDesc: "", //商品描述
        isVisible: true //是否上架
      }
    };
  },
  methods: {
    //列表图
    handleAvatarSuccess(res) {
      console.log(res);
      this.imageUrl = res.data.url;
    },
    beforeAvatarUpload() {
      //图片验证
    },
    // 轮播图
    handleRemove(file, fileList) {
      let index = this.bannerList.findIndex(item => {
        return item.url == file.url;
      });
      if (index != -1) {
        this.bannerList.splice(index, 1);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    bananerSuccess(res, file) {
      this.bannerList.push({ url: file.response.data.url });
    },
    detailSuccess(res, file) {
      this.detailList.push({ url: file.response.data.url });
    },
    handlePictureCardPreviewDetail(file) {
      this.dialogImageUrlDetail = file.url;
      this.dialogVisibleDetail = true;
    },
    handleRemoveDetail(file, fileList) {
      let index = this.detailList.findIndex(item => {
        return item.url == file.url;
      });
      if (index != -1) {
        this.detailList.splice(index, 1);
      }
    },
    reset() {
      this.rightTableData.dimCode = "";
      this.rightTableData.attrName = "";
      this.cookName = "";
      this.addName = "";
      this.getRightTable();
    },
    // 删除做法分组
    deleteOneGroup(i, dimName) {
      var arr = [];
      arr = this.selectCook.filter(p => {
        return p.dimName != dimName;
      });
      console.log(arr, "删选后");
      this.selectCook = arr;
      this.form.practiceDimList.splice(i, 1);
    },
    // 删除加料分组
    doleteAddGroup(i, dimName) {
      var arr = [];
      arr = this.selectAdd.filter(p => {
        return p.dimName != dimName;
      });
      console.log(arr, "删选后");
      this.selectAdd = arr;
      this.form.feedDimList.splice(i, 1);
    },
    // 做法选择确认按钮
    cookTypeButton() {
      console.log(this.selectCook);
      let dataArr = [];
      this.selectCook.map(mapItem => {
        if (dataArr.length == 0) {
          dataArr.push({
            dimName: mapItem.dimName,
            productDimAttrList: [mapItem]
          });
        } else {
          let res = dataArr.some(item => {
            //判断
            if (item.dimName == mapItem.dimName) {
              item.productDimAttrList.push(mapItem);
              return true;
            }
          });
          if (!res) {
            //
            dataArr.push({
              dimName: mapItem.dimName,
              productDimAttrList: [mapItem]
            });
          }
        }
      });
      this.form.practiceDimList = dataArr;
      console.log(dataArr, "66666666666", this.form.practiceDimList);
      this.dialogCookType = false;
      //  获取到新数组
    },
    // 提交按钮
    submit() {
      console.log(this.form);
      if (this.form.productName == "") {
        this.$message.error("请输入菜品名称");
        return;
      }
      if (
        this.form.productType == "" ||
        this.form.productType.categoryName == null
      ) {
        this.$message.error("请选择菜品分类");
        return;
      }
      if (this.form.normalPrice == "") {
        this.$message.error("请输入商品基础价格");
        return;
      }
      if (this.form.onlineSalePrice == "") {
        this.$message.error("请输入小程序售价");
        return;
      }
      // this.form.practiceList=this.selectCook
      // this.form.feedList=this.selectAdd
      this.form.categoryCode = this.form.productType.categoryCode;
      this.form.categoryName = this.form.productType.categoryName;

      if (
        this.form.specsDimAttrList != null &&
        this.form.specsDimAttrList.length != 0
      ) {
        this.form.specsDimAttrList.forEach((item, index) => {
          item.dimName = item.sizeName.dimName;
          item.dimCode = item.sizeName.dimCode;
          item.attrName = "规格" + (index + 1);
        });
      }
      let feedarr = [];
      this.form.feedDimList.forEach(i => {
        if (i.productDimAttrList.length == 0) {
        } else {
          i.dimCode = i.productDimAttrList[0].dimCode;
          feedarr.push(i);
        }
      });
      this.form.feedDimList = feedarr;
      console.log(feedarr);
      //  this.form.feedDimList.forEach(item=>{
      //   item.dimCode=item.productDimAttrList[0].dimCode
      // })

      let practarr = [];
      this.form.practiceDimList.forEach(item => {
        if (item.productDimAttrList.length == 0) {
        } else {
          item.dimCode = item.productDimAttrList[0].dimCode;
          practarr.push(item);
        }
      });
      this.form.practiceDimList = practarr;
      // 去除加料和做法的id
      if (this.form.specsDimAttrList.length != 0) {
        var flag = this.form.specsDimAttrList.some(item => {
          return item.dimName == undefined || item.normalPrice == "";
        });
      }
      if (flag) {
        //无 售价或规格名称
        this.$message.error("请填写规格售价及名称");
        return;
      }
      this.form.smallImg = this.imageUrl;
      this.form.bigImg = this.imageUrl;
      this.form.bannerList = this.bannerList;
      this.form.detailList = this.detailList;
      //  轮播图和详情图
      this.saveLoading = true;
      this.$http
        .post("/merchantProducts/saveMerchantProduct", this.form)
        .then(res => {
          console.log(res);
          this.saveLoading = false;
          if (res.data.code == 200) {
            this.$message({ type: "success", message: "保存成功" });
            this.saveLoading = false;
            this.$router.push("/merchantProduct");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    deleteSelectCook(i, index, attrName) {
      // this.selectCook.splice(i,1)
      console.log(
        i,
        index,
        this.form.practiceDimList,
        attrName,
        this.selectCook
      );
      this.form.practiceDimList[i].productDimAttrList.splice(index, 1);
      // var needCook=[]
      this.selectCook.forEach((item, ItemIndex) => {
        if (item.attrName == attrName) {
          console.log("删除了", item.attrName, ItemIndex);
          this.selectCook.splice(ItemIndex, 1);
        }
      });

      console.log(this.selectCook, "去除后");
    },
    deleteSelectAdd(i, index, attrName) {
      // console.log(i,index,this.form.practiceDimList,attrName,this.selectCook)
      this.form.feedDimList[i].productDimAttrList.splice(index, 1);
      this.selectAdd.forEach((item, ItemIndex) => {
        if (item.attrName == attrName) {
          console.log("删除了", item.attrName, ItemIndex);
          this.selectAdd.splice(ItemIndex, 1);
        }
      });
      console.log(this.selectAdd, "去除后");
    },
    // 添加加料
    async addBut() {
      console.log("-----");
      // this.getLeftType()
      // this.dialogCookType=false
      this.rightTableData.dimType = "feed";
      this.leftTypeActive = "-1";
      this.leftDimName = "全部";
      this.rightTableData.dimCode = null;
      this.getAddLeft();
      this.dialogAddMore = true;
      let ress = await this.getRightTable();
      if (this.selectAdd.length != 0) {
        let needs = this.selectAdd;
        console.log(this.selectAdd, "要回显的列");
        this.$refs.tableRight.clearSelection();
        let arrs = [];
        this.tableRight.forEach(item => {
          needs.forEach(i => {
            if (item.attrCode == i.attrCode) {
              arrs.push(item);
            }
          });
        });
        // setTimeout(()=>{
        // this.$refs.tableRight.clearSelection();
        arrs.forEach(it => {
          console.log("回显个数", it);
          this.$refs.tableRight.toggleRowSelection(it, true);
        });
        // },0)
      } else {
        // setTimeout(()=>{
        this.$refs.tableRight.clearSelection();
        // },0)
      }
    },
    getRowKeys(row) {
      //唯一值
      return row.attrCode;
    },
    // 添加加料确认按钮
    addButton() {
      this.dialogAddMore = false;
      let dataArr = [];
      this.selectAdd.map(mapItem => {
        if (dataArr.length == 0) {
          dataArr.push({
            dimName: mapItem.dimName,
            productDimAttrList: [mapItem]
          });
        } else {
          let res = dataArr.some(item => {
            //判断相同
            if (item.dimName == mapItem.dimName) {
              item.productDimAttrList.push(mapItem);
              return true;
            }
          });
          if (!res) {
            //如果没找相同日期添加一个新对象
            dataArr.push({
              dimName: mapItem.dimName,
              productDimAttrList: [mapItem]
            });
          }
        }
      });
      this.form.feedDimList = dataArr;
    },
    handleSelectionChange(val) {
      this.selectCook = val;
      // console.log(val,'做法')
    },
    searchByName() {
      //搜索
      this.rightTableData.attrName = this.cookName;
      this.getRightTable();
    },
    searchByAddName() {
      this.rightTableData.attrName = this.addName;
      this.getRightTable();
    },
    handleSelectionChangeAdd(val) {
      this.selectAdd = val;
      // console.log(this.selectAdd,'加料')
    },
    searchLeft(dimName, index, dimCode) {
      this.leftDimName = dimName;
      this.leftTypeActive = index;
      this.rightTableData.dimCode = dimCode;
      this.getRightTable();
    },
    async getRightTable() {
      // console.log(this.rightTableData)
      let r = await this.$http
        .post("/merchantDimAttr/queryList", this.rightTableData)
        .then(res => {
          this.tableRight = res.data.data;
          return res;
        });
      return r;
    },
    doDefault(obj, i) {
      // console.log(obj,i)
      this.form.specsDimAttrList.forEach(item => {
        item.defaultFlag = "";
      });
      this.form.specsDimAttrList[i].defaultFlag = "1";
    },
    getPinYin() {
      this.form.pinyin = pinyin(this.form.productName, {
        pattern: "first"
      }).replace(/\s+/g, "");
    },
    // 菜品分类下拉框
    getSelect() {
      this.$http
        .post("/merchantProductsCategory/queryList", {
          merchantCode: localStorage.getItem("merchantCode")
        })
        .then(res => {
          this.dishType = res.data.data;
        });
    },
    // 规格名称
    getTypeName() {
      this.$http
        .post("/merchantDim/queryLeftMenu", {
          merchantCode: this.form.merchantCode,
          dimType: "specs"
        })
        .then(res => {
          this.typeName = res.data.data;
        });
    },
    async getLeftType() {
      console.log("添加做法");
      this.dialogCookType = true;
      this.leftTypeActive = "-1";
      this.leftDimName = "全部";
      this.rightTableData.dimCode = null;
      this.rightTableData.dimType = "practice";
      this.$http
        .post("/merchantDim/queryLeftMenu", {
          merchantCode: this.form.merchantCode,
          dimType: "practice"
        })
        .then(res => {
          this.leftType = res.data.data;
        });
      let re = await this.getRightTable();
      console.log(re, "huoqu----------");
      if (this.selectCook.length != 0) {
        console.log("wqk");
        var need = this.selectCook;
        this.$refs.tableRights.clearSelection();
        let arr = [];
        this.tableRight.forEach(item => {
          need.forEach(i => {
            if (i.attrCode == item.attrCode) {
              arr.push(item);
            }
          });
        });
        console.log(arr, "要回显的列", "清空");
        // setTimeout(()=>{
        // this.$refs.tableRight.clearSelection()
        // console.log(this.$ref,this.$refs.tableRight)
        arr.forEach(it => {
          console.log("回显个数", it);
          this.$refs.tableRights.toggleRowSelection(it, true);
        });
        // },0)
      } else {
        console.log("qk");
        // setTimeout(()=>{
        this.$refs.tableRights.clearSelection();
        // },0)
      }
    },
    getAddLeft() {
      this.$http
        .post("/merchantDim/queryLeftMenu", {
          merchantCode: this.form.merchantCode,
          dimType: "feed"
        })
        .then(res => {
          this.AddLeft = res.data.data;
        });
    },
    // 添加
    addOneType() {
      this.form.specsDimAttrList.push({
        sizeName: {},
        dimName: "",
        defaultFlag: "",
        normalPrice: "",
        memberPrice: "",
        costPrice: "",
        barCode: "",
        lunchBoxPrice: ""
      });
    },
    // 删除
    deleteOne(i) {
      this.form.specsDimAttrList.splice(i, 1);
      var flag = false;
      this.form.specsDimAttrList.forEach(item => {
        if (item.defaultFlag == 1) {
          flag = true;
          return;
        }
        if (flag == false) {
          this.form.specsDimAttrList[0].defaultFlag = "1";
        }
      });
    },
    changeSel(val) {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 自动生成会员价
    changePrice() {
      this.form.memberPrice = this.form.normalPrice;
      this.form.onlineSalePrice = this.form.normalPrice;
    },
    // 跳转做法
    goToDetailCook() {
      this.dialogCookType = false;
      this.$router.push("/merchantProductRecipes?add=true");
    },
    // 加料跳转
    goToDetailAdd() {
      this.dialogCookType = false;
      this.$router.push("/merchantProductFeedingManagement?add=true");
    },
    //
    cancelSelectCook(i, code) {
      console.log(code);
      let row = this.tableRight.find(val => {
        return val.attrCode == code;
      });
      console.log(row);
      this.$refs.tableRights.toggleRowSelection(row, false);
      console.log(this.selectCook, i);
      // this.selectCook.splice(i,1)
    },
    cancelSelectAdd(i, code) {
      console.log("去除");
      let row = this.tableRight.find(val => {
        return val.attrCode === code;
      });
      this.$refs.tableRight.toggleRowSelection(row, false);
    },
    //回显
    getLoadInfo() {
      var info = {};
      info.id = this.$route.query.id;
      info.productCode = this.$route.query.productCode;
      info.isCombo = this.$route.query.isCombo;
      info.merchantCode = localStorage.getItem("merchantCode");
      this.$http.post("/merchantProducts/queryOne", info).then(res => {
        // console.log(res,'回显数据66')
        this.form = res.data.data;
        if (res.data.data.isWeighSell !== null) {
          this.form.isWeighSell = res.data.data.isWeighSell.toString();
        }
        this.form.productType = {};
        this.form.productType.categoryCode = res.data.data.categoryCode;
        this.form.productType.categoryName = res.data.data.categoryName;
        this.form.specsDimAttrList.forEach(item => {
          item.sizeName = {};
          item.sizeName.dimName = item.dimName;
          item.sizeName.dimCode = item.dimCode;
        });
        if (this.form.isVisible == 1) {
          this.form.isVisible = true;
        } else {
          this.form.isVisible = false;
        }
        var arr = [];
        res.data.data.practiceDimList.forEach(item => {
          item.productDimAttrList.forEach(it => {
            arr.push(it);
          });
        });
        this.imageUrl = res.data.data.smallImg;
        this.bannerList = res.data.data.bannerList;
        this.detailList = res.data.data.detailList;
        this.selectCook = arr;
        console.log("回显的cook", this.selectCook);
        var arrs = [];
        res.data.data.feedDimList.forEach(item => {
          item.productDimAttrList.forEach(it => {
            arrs.push(it);
          });
        });
        this.selectAdd = arrs;
        //  console.log(arr,'获取的选中项',this.selectCook)
      });
    },
    scrollInto(id) {
      let dom = document.getElementById(id);
      dom.scrollIntoView({
        behavior: "smooth"
      });
    }
  },
  created() {
    this.form.merchantCode = localStorage.getItem("merchantCode");
    this.form.merchantName = localStorage.getItem("merchantName");
    this.rightTableData.merchantCode = localStorage.getItem("merchantCode");
    this.getSelect();
    this.getTypeName();
    if (
      this.$route.query.productCode !== "" &&
      this.$route.query.productCode != undefined
    ) {
      console.log("回显");
      this.getLoadInfo();
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.main-content {
  height: 62vh;
  overflow: auto;
  // margin-top: 20px;
  padding: 20px;
  padding-top: 0;
  .line {
    display: inline-block;
    width: 4px;
    height: 18px;
    background-color: #ffbd00;
    margin-right: 5px;
    border-radius: 2px;
    margin-bottom: -2px;
  }
}
.main-box {
  background-color: #fff;
  padding-top: 16px;
  .nav-menu {
    padding-left: 32px;
    width: 100%;
    background-color: rgb(248, 248, 248);
    display: flex;
    .item {
      color: #333;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      width: 80px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .item:hover {
      color: #ff6000;
    }
  }
}
.title {
  padding-left: 24px;
  height: 24px;
  margin-bottom: 24px;
  // border-bottom: 2px solid #f6f6f6;
  display: flex;
  align-items: center;
  span {
    margin-left: 6px;
  }
  i,
  span {
    font-size: 18px;
    font-weight: 500;
    color: #222;
  }
}
.base-info {
  margin: 30px 0px 30px 20px;
}
/deep/ .el-form-item__label {
  color: #333;
}
/deep/.inline-form {
  .el-form--inline .el-form-item {
    margin-right: 14px;
  }
  .el-form-item__label {
    padding-bottom: 0 !important;
  }
}
.default-text {
  padding: 0 7px;
  color: #fff;
  background: #ffd100;
  border: 1px solid #e9e9e9;
  width: 24px;
  line-height: 21px;
  margin-left: 6px;
  font-size: 12px;
  height: 21px;
  display: inline-block;
}
/deep/ .is-default {
  .el-form-item__content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  .el-radio:last-child {
    margin-right: 0;
    transform: translateY(2px);
  }
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #ffd100;
  background-color: #ffd100;
}
/deep/ .dishType-head {
  background-color: #f7f7f7;
  display: flex;
  justify-content: space-between;
  height: 32px;
  padding-left: 14px;
  color: #333;
  font-weight: 500;
  .left {
    display: flex;
    align-items: center;
  }
  .right {
    margin-right: 18px;
    color: #ff6000;
    cursor: pointer;
  }
}
.addOne {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  cursor: pointer;
  border-radius: 4px;
  background: #f7f7f7;
  border: 1px solid #f7f7f7;
  font-weight: 500;
  color: #ff6000;
  font-size: 14px;
}
/deep/ .myBtn {
  background-color: #ffd100;
  color: #222;
}
/deep/ .myBtn:hover {
  color: #222;
}
/deep/.box-main {
  display: flex;
  .left {
    display: flex;
    flex-direction: column;
    .item {
      width: 129px;
      height: 34px;
      margin-bottom: 12px;
      padding-left: 12px;
      line-height: 34px;
      color: #333;
    }
    .item.active {
      background-color: #fff2cc;
    }
  }
  .right {
    width: 100%;
    padding-left: 12px;
    margin-left: 6px;
    border-left: 1px solid rgba(0, 0, 0, 0.09);
    .top {
      display: flex;
      margin-bottom: 28px;
      .h32 {
        height: 34px;
        font-size: 14px;
      }
      .h32.btn-my {
        background-color: #ffbd00;
        color: #000;
        padding-left: 15px;
        padding-right: 15px;
      }
      .el-input__inner {
        height: 34px !important;
      }
      .h32.el-input.el-input--small {
        width: 202px;
      }
    }
  }
}
/deep/ thead th {
  color: #333;
  font-weight: 400 !important;
}
/deep/ .el-select {
  width: 320px;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #222;
}
/deep/ .long-label {
  display: flex;
  .el-form-item__label {
    width: 144px !important;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.foot {
  display: flex;
  justify-content: right;
  height: 100px;
  background-color: #fff;
  padding-right: 60px;
}
/deep/ .groupByType {
  margin-block-start: 14px;
  border: 1px solid #e8e8e8;
  padding-left: 8px;
  padding-right: 8px;
  color: #333;
  font-weight: 500;
  .top {
    height: 38px;
    line-height: 38px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    .left {
      font-size: 14px;
    }
    .right {
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
/deep/ .el-table-column--selection .cell {
  padding-left: 10px;
}
/deep/ .btnAll {
  background: #fff;
  color: #222;
  border: 1px solid #dcdfe6;
}
/deep/ .btnCancel:hover {
  color: #222;
  border: 1px solid #dcdfe6;
}
/deep/ .btnSubmit {
  background-color: #ffbd00;
}
/deep/ .text-center {
  label {
    transform: translateY(10px);
  }
}

/deep/ .dialog-footer {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  .red {
    color: #ff6000;
    font-size: 14px;
    cursor: pointer;
  }
}

/deep/ .hasSelect {
  display: flex;
  flex-wrap: wrap;
  .item {
    cursor: pointer;
    font-size: 12px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding-left: 7px;
    padding-right: 7px;
    border: 1px solid #e5e5e5;
    color: #333;
    user-select: none;
    line-height: 20px;
    background-color: #fafafa;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
.avatar {
  width: 140px;
  height: 140px;
  display: block;
}
.avatar-uploader-icon {
  border: 1px dashed #8c939d;
}
</style>
